export default __webpack_public_path__ + "222e871908092970a28ada1996336366.jpeg";